import { GeneralActionTypes } from "../actions";
import { SessionStorage } from "../../helpers";

const initState = {
  map: null,
  betSlipConfiguration: null,
  doc: null,
  webFiles: null,
  url: null,
  fileName: "",
  betCode: SessionStorage.betCode || "",
  bets: "",
  message: "",
  betCodeError: "",
  drillDownGroups: [],
  drillDownGroupsError: "",
  currencies: "",
  prefixes: "",
  countries: "",
  counties: "",
  configuration: {},
  coupon: null,
  validateCouponMessage: null,
  validateCouponError: null,
  validateCouponLoading: false,
  ActiveSpinAndWinTables: false,
};

const general = (state = initState, action) => {
  switch (action.type) {
    case GeneralActionTypes.Get_Currencies_Error:
      return {
        ...state,
        message: action.message,
        currencies: "",
      };

    case GeneralActionTypes.Get_Currencies_Success:
      return {
        ...state,
        currencies: action.data,
      };

    case GeneralActionTypes.Map_Success:
      return {
        ...state,
        map: action.data,
      };

    case GeneralActionTypes.Bet_Slip_Configuration_Success:
      return {
        ...state,
        betSlipConstants: action.betSlipConstants,
        betFormMinMaxAmounts: action.betFormMinMaxAmounts,
        betsRestrictions: action.betsRestrictions,
        minimumBetsAmount: action.minimumBetsAmount,
        loyaltyRewardDetails: action.loyaltyRewardDetails
      };
    case GeneralActionTypes.Form_Statuses_Success: {
      return {
        ...state,
        statuses: action.data,
      };
    }
    case GeneralActionTypes.Page_Name_Success:
      return {
        ...state,
        doc: action.data,
      };
    case GeneralActionTypes.Web_Files_Success:
      return {
        ...state,
        webFiles: action.data,
      };
    case GeneralActionTypes.Web_File_Response:
      return {
        ...state,
        url: action.url,
        fileName: action.fileName,
      };
    case GeneralActionTypes.Create_Bet_Code_Request:
      return {
        ...state,
        creatBetCodeLoading: true,
        message: "",
      };
    case GeneralActionTypes.Create_Bet_Code_Success:
      return {
        ...state,
        betCode: action.code,
        message: "",
        creatBetCodeLoading: false,
      };
    case GeneralActionTypes.Create_Bet_Code_Error:
      return {
        ...state,
        message: action.message,
        creatBetCodeLoading: false,
      };
    case GeneralActionTypes.Bets_By_Bet_Code_Success:
      return {
        ...state,
        bets: action.data,
        betCodeError: "",
      };
    case GeneralActionTypes.Bets_By_Bet_Code_Error:
      return {
        ...state,
        betCodeError: action.message,
      };
    case GeneralActionTypes.Remove_BetCode:
      return {
        ...state,
        betCode: null,
      };
    case GeneralActionTypes.Get_DrillDown_Groups_Success:
      return {
        ...state,
        drillDownGroups: action.data,
      };
    case GeneralActionTypes.Get_DrillDown_Groups_Error:
      return {
        ...state,
        drillDownGroupsError: action.message,
      };
    case GeneralActionTypes.Get_Configuration_Success:
      return {
        ...state,
        configuration: action.data,
      };
    case GeneralActionTypes.Get_Configuration_Error:
      return {
        ...state,
        configurationError: action.message,
      };
    case GeneralActionTypes.Get_CountryPhone_Providers_Success:
      return {
        ...state,
        prefixes: action.prefixes,
      };
    case GeneralActionTypes.Get_Countries_Success:
      return {
        ...state,
        countries: action.countries,
      };

    case GeneralActionTypes.Get_Counties_Success:
      return {
        ...state,
        counties: action.counties,
      };
    case GeneralActionTypes.Get_Banners_Request:
      return {
        ...state,
        loadingBanners: true,
      };
    case GeneralActionTypes.Get_Banners_Success:
      return {
        ...state,
        loadingBanners: false,
        promotionalBanners: action.promotionalBanners,
      };
    case GeneralActionTypes.Get_Banners_Error:
      return {
        ...state,
        loadingBanners: false,
        promotionalBannersError: action.promotionalBannersError,
      };
    case GeneralActionTypes.Get_Calender_Request:
      return {
        ...state,
        loadingCalender: true,
      };
    case GeneralActionTypes.Get_Calender_Success:
      return {
        ...state,
        loadingCalender: false,
        calenderImages: action.calenderImages,
      };
    case GeneralActionTypes.Get_Calender_Error:
      return {
        ...state,
        loadingCalender: false,
        calenderImagesError: action.calenderImagesError,
      };
    case GeneralActionTypes.Get_Footer_Providers_Request:
      return {
        ...state,
        loadingFooterProviders: true,
      };
    case GeneralActionTypes.Get_Footer_Providers_Success:
      return {
        ...state,
        loadingFooterProviders: false,
        footerProviders: action.footerProviders,
      };
    case GeneralActionTypes.Get_Footer_Providers_Error:
      return {
        ...state,
        loadingFooterProviders: false,
        footerProvidersError: action.footerProvidersError,
      };

    case GeneralActionTypes.Get_Footer_Text_Request:
      return {
        ...state,
        loadingFooterText: true,
      };
    case GeneralActionTypes.Get_Footer_Text_Success:
      return {
        ...state,
        loadingFooterText: false,
        footerText: action.footerText,
      };
    case GeneralActionTypes.Get_Footer_Text_Error:
      return {
        ...state,
        loadingFooterText: false,
        footerTextError: action.footerTextError,
      };


    case GeneralActionTypes.Get_Country_Flag_Images:
      return {
        ...state,
        loadingCountryFlags: true,
      };
    case GeneralActionTypes.Get_Country_Flag_Images_Success:
      return {
        ...state,
        loadingCountryFlags: false,
        countryFlags: action.countryFlags,
      };
    case GeneralActionTypes.Get_Country_Flag_Images_Error:
      return {
        ...state,
        loadingCountryFlags: false,
        countryFlagsError: action.countryFlagsError,
      };

      
    case GeneralActionTypes.Get_Sport_Types_Icons_Request:
      return {
        ...state,
        loadingSportTypesIcons: true,
      };

    case GeneralActionTypes.Get_Sport_Types_Icons_Success:
      return {
        ...state,
        loadingSportTypesIcons: false,
        sportTypesIcons: action.sportTypesIcons,
      };

    case GeneralActionTypes.Get_Sport_Types_Icons_Error:
      return {
        ...state,
        loadingSportTypesIcons: false,
        sportTypesIconsError: action.sportTypeIconsError,
      };

      
    case GeneralActionTypes.Validate_Coupon_Request:
      return {
        ...state,
        validateCouponLoading: true,
        validateCouponMessage: null,
        validateCouponError: null,
      };
    case GeneralActionTypes.Validate_Coupon_Success:
      return {
        ...state,
        coupon: action.data,
        message: "",
        validateCouponMessage: action.message,
        couponName: action.couponName,
        validateCouponError: null,
        validateCouponLoading: false,
      };
    case GeneralActionTypes.Validate_Coupon_Reset:
      return {
        ...state,
        validateCouponMessage: null,
        couponName: null,
        validateCouponError: null,
        validateCouponLoading: false,
      };
    case GeneralActionTypes.Validate_Coupon_Error:
      return {
        ...state,
        validateCouponError: action.message,
        validateCouponMessage: null,
        validateCouponLoading: false,
      };

    case GeneralActionTypes.Coupon_Reset:
      return {
        ...state,
        coupon: null,
        validateCouponError: null,
        validateCouponMessage: null,
        validateCouponLoading: false,
      };
    case GeneralActionTypes.Validate_Coupon_Clear_Message:
      return {
        ...state,
        validateCouponError: null,
        validateCouponMessage: null,
        validateCouponLoading: false,
      };

    case GeneralActionTypes.Get_Loyalty_Rewards_Options_Request:
      return {
        ...state,
        loadingLoyalityRewards: true,
        
      };
    case GeneralActionTypes.Get_Loyalty_Rewards_Options_Success:
      return {
        ...state,
        loadingLoyalityRewards: false,
        loyalityRewardOptions: action.loyalityRewardOptions,
        loyalityRewardOptionsError: undefined
      };
    case GeneralActionTypes.Get_Loyalty_Rewards_Options_Error:
      return {
        ...state,
        loadingLoyalityRewards: false,
        loyalityRewardOptions: undefined,
        loyalityRewardOptionsError: action.loyalityRewardOptionsError
        
      };
    case GeneralActionTypes.Get_Sport_Promos_Request:
      return {
        ...state,
        loadingPromos: true,
        promosError: undefined,
        promosList : undefined
        
      };
    case GeneralActionTypes.Get_Sport_Promos_Suceess:
      return {
        ...state,
        loadingPromos: false,
        promosError: undefined,
        promosList : action.promosList
      };
    case GeneralActionTypes.Get_Sport_Promos_Error:
      return {
        ...state,
        loadingPromos: false,
        promosError: action.promosError,
        promosList : undefined
        
      };
    case GeneralActionTypes.Get_Sport_Promos_Info_Request:
      return {
        ...state,
        loadingPromoInfo: true,
        promoInfoError: undefined,
        singlePromoInfo : undefined
        
      };
    case GeneralActionTypes.Get_Sport_Promos_Info_Suceess:
      return {
        ...state,
        loadingPromoInfo: false,
        promoInfoError: undefined,
        singlePromoInfo : action.singlePromoInfo
      };
    case GeneralActionTypes.Get_Sport_Promos_Info_Error:
      return {
        ...state,
        loadingPromoInfo: false,
        promoInfoError: action.promoInfoError,
        singlePromoInfo : undefined
        
      };
    case GeneralActionTypes.Reset_Get_Sport_Promos_Info_Request:
      return {
        ...state,
        loadingPromoInfo: undefined,
        promoInfoError: undefined,
        singlePromoInfo : undefined
      };
    case GeneralActionTypes.Reset_Get_Sport_Promos:
      return {
        ...state,
        loadingPromos: undefined,
        promosError: undefined,
        promosList : undefined
      };


    case GeneralActionTypes.Get_Header_Tabs_Request:
      return {
        ...state,
        loadingHeaderTabs: true,
        headerTabs: undefined,
        headerTabsError: undefined
      };
    case GeneralActionTypes.Get_Header_Tabs_Success:
      return {
        ...state,
        loadingHeaderTabs: false,
        headerTabs: action.headerTabs,
        headerTabsError: undefined
      };
    case GeneralActionTypes.Get_Header_Tabs_Error:
      return {
        ...state,
        loadingHeaderTabs: false,
        headerTabs: undefined,
        headerTabsError: action.headerTabsError
      };
    case GeneralActionTypes.Active_Spin_And_Win_Table:
      return {
        ...state,
        ActiveSpinAndWinTables: action.data
      };
      case GeneralActionTypes.Get_Lucky_Number_Configuration_Request:
        return {
          ...state,
          loadingLuckyNumberConfigration: true,
          luckyNumberConfigration: undefined,
          luckyNumberConfigrationError: undefined
        };
      case GeneralActionTypes.Get_Lucky_Number_Configuration_Success:
        return {
          ...state,
          loadingLuckyNumberConfigration: false,
          luckyNumberConfigration: action.luckyNumberConfigration,
          howToPlayText: action.howToPlayText,
          luckyNumberFooters: action.luckyNumberFooters,
          luckyNumberHomePageTexts: action.luckyNumberHomePageTexts,
          luckyNumberTabs: action.luckyNumberTabs,
          luckyNumberUpcomintDraws: action.luckyNumberUpcomintDraws,
          luckyNumberUpcomingDrawsPageTexts: action.luckyNumberUpcomingDrawsPageTexts,
          luckyNumberResultsPageTexts: action.luckyNumberResultsPageTexts,
          luckyNumberConfigrationError: undefined
        };
      case GeneralActionTypes.Get_Lucky_Number_Configuration_Error:
        return {
          ...state,
          loadingLuckyNumberConfigration: false,
          luckyNumberConfigration: undefined,
          luckyNumberConfigrationError: action.error
        };
      case GeneralActionTypes.Get_Landing_Configuration_Request:
        return {
          ...state,
          loadingLandingPage:true
        };
      case GeneralActionTypes.Get_Landing_Configuration_Success:
        return {
          ...state,
          loadingLandingPage:false,
          landingBanners: action.banners,
          landingPromos: action.promos,
          landingSlotsGame: action.slotsGame,
          landingBettingImage: action.bettingImagePath,
          sections: action.sections,
        };
      case GeneralActionTypes.Get_Landing_Configuration_Error:
        return {
          ...state,
          loadingLandingPage:false,
          landingPageError: action.error
        };
      case GeneralActionTypes.Get_Work_With_Us_Configuration_Request:
        return {
          ...state,
          loadingWorkWithUs:true
        };
      case GeneralActionTypes.Get_Work_With_Us_Configuration_Success:
        return {
          ...state,
          loadingWorkWithUs:false,
          workWithUsSections: action.workWithUsSections,
          workWithUsBanner: action.workWithUsBanner,
          workWithUsMobileBanner: action.workWithUsMobileBanner
        };
      case GeneralActionTypes.Get_Work_With_Us_Configuration_Error:
        return {
          ...state,
          loadingWorkWithUs:false,
          workWithUsError: action.error
        };
    
      case GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Request:
        return {
          ...state,
          loadingKioskBanners:true
        };
      case GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Success:
        return {
          ...state,
          loadingKioskBanners:false,
          kioskBanners: action.kioskBanners,
          bannerGroupId: action.bannerGroupId,
        };
      case GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Error:
        return {
          ...state,
          loadingKioskBanners:false,
          kioskBannersError: action.error
        };
    
    default:
      return state;
  }
};

export default general;
